var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuteWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_47940920281089238772833034316347580966",
    d: "M16.181.214c.297-.236.702-.28 1.046-.117.342.164.56.505.56.88v25.365c0 .374-.218.716-.56.878-.136.064-.283.097-.429.097-.22 0-.439-.072-.619-.213l-9.61-7.591H1.976C.887 19.513 0 18.638 0 17.56V9.757c0-1.075.887-1.951 1.976-1.951H6.57zm5.12 10.678l2.371 2.372 2.29-2.29.401.402-2.289 2.29 2.372 2.371-.389.388-2.371-2.371-2.29 2.289-.401-.402 2.289-2.29-2.372-2.37.389-.389z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_151466761216615595966707486939865553082",
    d: "M-2.763 -3.152H29.696000000000005V30.469H-2.763z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -520) translate(148 512) translate(16 8) translate(2.341 2.341)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_236715509788909365078829096470895990329",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_47940920281089238772833034316347580966"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_47940920281089238772833034316347580966"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_236715509788909365078829096470895990329)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#hinava_random_uuid_151466761216615595966707486939865553082"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteWhite);
export default __webpack_public_path__ + "static/media/mute-white.c8df6063280201faf937a6996072afb7.svg";
export { ForwardRef as ReactComponent };